"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_i18next_1 = require("react-i18next");
var i18n_1 = require("../../i18n");
var Root_1 = require("../Root/Root");
var uuid = require("uuid/v4");
var css = require("./DealerViewer.scss");
var fedops_logger_1 = require("@wix/fedops-logger");
var interfaces_1 = require("../../interfaces");
var src_1 = require("@wix/dealer-store/dist/src");
var BiLogger_1 = require("@wix/dealer-common/dist/src/services/BiLogger");
var _get = require("lodash/get");
var bi_events_1 = require("@wix/dealer-common/dist/src/services/BiLogger/bi-events");
var DimensionCalculator_1 = require("@wix/dealer-common/dist/src/services/DimensionCalculator");
var viewerUrl = interfaces_1.viewerPropTypes.viewerUrl, propTypes = tslib_1.__rest(interfaces_1.viewerPropTypes, ["viewerUrl"]);
var DealerViewerComp = /** @class */ (function (_super) {
    tslib_1.__extends(DealerViewerComp, _super);
    function DealerViewerComp(props) {
        var _this = _super.call(this, props) || this;
        _this.hasError = false;
        _this.getMetasiteGuid = function (props) {
            var metaSiteId = _get(props, 'dealerOptions.metaSiteId', props.metaSiteId);
            var metasiteGuid = _get(props, 'dealerOptions.metasiteGuid', props.metasiteGuid);
            return metaSiteId || metasiteGuid;
        };
        _this.log = function (eventId, additionalParams, _a) {
            if (additionalParams === void 0) { additionalParams = {}; }
            var _b = (_a === void 0 ? {} : _a).newEventStyle, newEventStyle = _b === void 0 ? true : _b;
            return _this.biLogger.log(eventId, newEventStyle, additionalParams, _this.cmsDataStore.getLocale(), _this.cmsDataStore.getMetaSiteId(), _this.cmsDataStore.getBannerRoot(), _this.cmsDataStore.getBannerPosition());
        };
        _this.onDealerError = function () {
            _this.hasError = true;
            _this.forceUpdate();
            if (_this.props.onError) {
                _this.props.onError();
            }
        };
        _this.createOnDealerView = function (onView) { return function (aboveTheFold) {
            _this.logBiView(aboveTheFold);
            if (onView) {
                onView();
            }
        }; };
        _this.logBiView = function (aboveTheFold) {
            return _this.log(bi_events_1.VIEW_EVENT, { aboveTheFold: aboveTheFold }, { newEventStyle: false });
        };
        _this.state = {
            loaded: false,
            empty: false,
        };
        var fedopsLogger = fedops_logger_1.create('react-dealer-viewer');
        _this.biLogger = new BiLogger_1.BiLogger(props.additionalBiParams);
        var data = {
            bannerPosition: _this.props.bannerPosition,
            locale: _this.props.locale,
            metasiteGuid: _this.getMetasiteGuid(_this.props),
            onClick: _this.props.onClick,
            onDisplay: _this.props.onDisplay,
            onEmpty: _this.props.onEmpty,
            onView: _this.props.onView,
            onError: _this.props.onError,
            translationsUrl: _this.props.translationsUrl,
            fedopsLogger: fedopsLogger,
            banners: _this.props.banner,
            biLogger: _this.biLogger,
        };
        _this.cmsDataStore = new src_1.CmsDataStore(data);
        _this.requestGuid = uuid();
        _this.log(bi_events_1.BANNER_INIT, { requestGuid: _this.requestGuid }, { newEventStyle: true });
        return _this;
    }
    DealerViewerComp.prototype.componentDidMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isEmpty, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cmsDataStore.load()];
                    case 1:
                        isEmpty = (_a.sent()).isEmpty;
                        this.setState({ empty: isEmpty });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.setState({ loaded: false });
                        this.onDealerError();
                        return [2 /*return*/];
                    case 3:
                        this.setState({ loaded: true }, function () {
                            if (!_this.hasError) {
                                _this.log(bi_events_1.BANNER_RENDERED, { requestGuid: _this.requestGuid }, { newEventStyle: true });
                                _this.props.onDisplay &&
                                    _this.props.onDisplay({
                                        isDisplayed: _this.cmsDataStore.shouldShowBanner(),
                                        bannerLocationOnPage: _this.cmsDataStore.getBannerLocation(),
                                        width: DimensionCalculator_1.calculateWidth(_this.cmsDataStore.pageSettings, _this.cmsDataStore.getContext()),
                                        height: DimensionCalculator_1.calculateHeight(_this.cmsDataStore.pageSettings, _this.cmsDataStore.getContext()),
                                    });
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DealerViewerComp.prototype.render = function () {
        var onDealerView = this.createOnDealerView(this.cmsDataStore.getOnView());
        return (React.createElement("span", { className: css.dealerViewer }, this.hasError === false && !this.state.empty ? (React.createElement(Root_1.Root, { dealerOptions: this.props.dealerOptions, cmsDataStore: this.cmsDataStore, loaded: this.state.loaded, onView: onDealerView, onError: this.onDealerError })) : (React.createElement("span", { className: css.failedContainer }))));
    };
    DealerViewerComp.propTypes = tslib_1.__assign({}, propTypes);
    DealerViewerComp.defaultProps = tslib_1.__assign({}, interfaces_1.viewerDefaultProps);
    return DealerViewerComp;
}(React.Component));
exports.DealerViewerComp = DealerViewerComp;
var DealerViewer = /** @class */ (function (_super) {
    tslib_1.__extends(DealerViewer, _super);
    function DealerViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DealerViewer.getI18n = function (locale, translationsUrl) {
        if (DealerViewer.i18n === undefined) {
            DealerViewer.i18n = i18n_1.default({ locale: locale, baseUrl: translationsUrl });
        }
        return DealerViewer.i18n;
    };
    DealerViewer.prototype.render = function () {
        return (React.createElement(react_i18next_1.I18nextProvider, { i18n: DealerViewer.getI18n(this.props.locale, this.props.translationsUrl) },
            React.createElement(DealerViewerComp, tslib_1.__assign({}, this.props))));
    };
    return DealerViewer;
}(React.Component));
exports.DealerViewer = DealerViewer;
//# sourceMappingURL=DealerViewer.js.map